<template>
  <div class="d-flex" style="background: #EEECF1;">
    <div class="preview position-relative u-scrollbar-hidden" style="background: #FFFFFF; overflow-y: scroll;">
      <div class="m-auto w-100">
        <div class="d-flex flex-column align-items-center">
          <div class="fw-bold"><p>{{ getTitleText }}</p></div>

          <div class="d-flex" style="gap: 8px;">
            <div class="position-relative cursor-pointer" style="width: 100px; height: 40px;" @click="onClickReturnBtn()">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="40" viewBox="0 0 100 40" fill="none">
              <path d="M17.668 1H97C98.1046 1 99 1.89543 99 3V37C99 38.1046 98.1046 39 97 39H17.668C17.0655 39 16.495 38.7284 16.1152 38.2607L2.31152 21.2607C1.71513 20.5262 1.71513 19.4738 2.31152 18.7393L16.1152 1.73926C16.495 1.27158 17.0655 1 17.668 1Z" fill="white" stroke="#8C9BC6" stroke-width="2"/>
              </svg>
              <div class="position-absolute fw-bold" style="font-size: 16px; color: #8C9BC6; top: 8px; left: 32px;">もどる</div>
            </div>

            <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
              <DesignPreview />
            </div>

            <div class="d-flex flex-column justify-content-end" style="width: 203px; gap: 8px;">
              <PreviewModeBgColorOnly :isAcryl="false" :showModeSwitch="true" />
            </div>
          </div>
        </div>
      </div>
      <Precautions>
        <p class="m-0">・デザインを詰め込みすぎるとお客様によるカットが難しくなる場合があります。</p>
        <p class="m-0">・背景の透過処理がされていないデザインは、そのまま仕上がりますので、必ずプレビューをご確認ください。</p>
      </Precautions>
    </div>
    <div class="p-0" style="width: 316px; overflow: hidden;">
      <div class="right-menu">
        <RightMenuPrintPreview />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ProductId,
  GetCanvasSize,
  RightViewState,
} from "@/js/Const.js";

import PreviewModeBgColorOnly from "@/components/acyrpro/preview/PreviewModeBgColorOnly.vue";
import DesignPreview from "@/components/acyrpro/preview/DesignPreview.vue";
import RightMenuPrintPreview from "@/components/acyrpro/print/RightMenuPrintPreview_Ap.vue";
import Precautions from "@/components/acyrpro/preview/Precautions.vue";

export default {
  name: "CenterViewPrintPreview_Ap",
  props: {},
  components: {
    RightMenuPrintPreview,
    DesignPreview,
    PreviewModeBgColorOnly,
    Precautions,
  },
  data: function () {
    return {

    };
  },
  computed: {
    getCanvasSize(){
      let canvasSize = GetCanvasSize(this.$store.state.acryPrint.selectProductId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    getTitleText(){
      switch(this.$store.state.acryPrint.selectProductId){
        case ProductId.ACRY_PRINT_S: return "Sサイズ";
        case ProductId.ACRY_PRINT_M: return "Mサイズ";
        case ProductId.ACRY_PRINT_L: return "Lサイズ";
        default: return "";
      }
    },
  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    // this.$store.commit("setIsCenterViewScroll", false);

    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch((e) => {
      this.$handleError("031", e, { hideLoading: true });
    });

    this.$store.commit("hideLoading");
  },
  methods: {
    onClickReturnBtn(){
      this.$store.commit("setIsCenterViewScroll", true);
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("setPreviousCenterViewState");
    },
    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 2){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    hideModel(){
      this.$store.commit("hidePreviewTutorial");
    },
    getTop(top) {
      return {
        'top': `${top - this.$store.state.tutorial.previewTutorialScroll}px`,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview{
  min-width: 805px;
  // width: 100%;
  width: calc(100vw - #{$leftmenu-width} - 300px);
  padding: 16px 32px;
  height: calc(100vh - #{$header-height});
}

.control-area{
  margin-left: 16px;
  width: 243px;
}

.design {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.cutLine {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  opacity: 0.3;
}

.nonEditable {
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.5;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.nonEditable-modal{
  position: fixed;
  height: 80%;
  max-height: 742px;
  width: 750px;
  z-index: 3;
  background: white;
  border-radius: 4px;

  top: 10%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);

  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}
.preview-btn{
  height: 40px;
  margin-top: 8px;
  font-weight: bold;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 4px;
  background-color: $background-white-color;
}

.right-menu{
  background-color: $background-white-color;
  height: calc(100vh - #{$header-height});
  width: #{$rightmenu-width};
  margin: 0px 8px;
}
</style>
